var map = {
	"./Septris-sprite-02.png": "c416",
	"./Septris-sprite-bg.jpg": "556f",
	"./Septris-sprite-doors-closed.png": "a68b",
	"./Septris-sprite-doors-open.png": "3f9e",
	"./Septris-sprite-level-bg.png": "db76",
	"./Septris-sprite-or-bg.png": "3bff",
	"./Septris-sprite-start - with text.png": "9f19",
	"./Septris-sprite-start-old.png": "b1a5",
	"./Septris-sprite-start.png": "2638",
	"./background.jpg": "b13e",
	"./cat1.png": "f42e",
	"./cat2.png": "7853",
	"./cat3.png": "29a6",
	"./cat4.png": "bd4d",
	"./cat5.png": "c50b",
	"./cross.gif": "7af7",
	"./drsepsis.png": "850d",
	"./fishbone.gif": "5aca",
	"./icons/consult.png": "2ccc",
	"./icons/cultures.png": "70c3",
	"./icons/icon-stethoscope.png": "76fe",
	"./icons/imaging.png": "c619",
	"./icons/labs.png": "cbef",
	"./icons/menu.png": "56b4",
	"./icons/pause.png": "18cd",
	"./icons/play.png": "070a",
	"./icons/treat.png": "a01a",
	"./patient-tile-bg.png": "f87c",
	"./patients/ann_d.png": "7b14",
	"./patients/ann_h.png": "8982",
	"./patients/ann_n.png": "b897",
	"./patients/ann_s.png": "f188",
	"./patients/eileen_d.png": "0cf4",
	"./patients/eileen_h.png": "338b",
	"./patients/eileen_n.png": "edb1",
	"./patients/eileen_s.png": "4e15",
	"./patients/fr/anne_d.png": "f102",
	"./patients/fr/anne_h.png": "e73d",
	"./patients/fr/anne_n.png": "23aa",
	"./patients/fr/anne_s.png": "f320",
	"./patients/fr/helene_d.png": "c937",
	"./patients/fr/helene_h.png": "4ba2",
	"./patients/fr/helene_n.png": "b781",
	"./patients/fr/helene_s.png": "07f4",
	"./patients/fr/idriss_d.png": "88c3",
	"./patients/fr/idriss_h.png": "c160",
	"./patients/fr/idriss_n.png": "bfa6",
	"./patients/fr/idriss_s.png": "f905",
	"./patients/fr/marc_d.png": "f6d2",
	"./patients/fr/marc_h.png": "10c1",
	"./patients/fr/marc_n.png": "8d03",
	"./patients/fr/marc_s.png": "5851",
	"./patients/fr/matthieu_d.png": "7030",
	"./patients/fr/matthieu_h.png": "726f",
	"./patients/fr/matthieu_n.png": "ab0b",
	"./patients/fr/matthieu_s.png": "e99c",
	"./patients/fr/pierre_d.png": "d887",
	"./patients/fr/pierre_h.png": "3415",
	"./patients/fr/pierre_n.png": "5d02",
	"./patients/fr/pierre_s.png": "6082",
	"./patients/fr/regis_d.png": "6bdd",
	"./patients/fr/regis_h.png": "06f4",
	"./patients/fr/regis_n.png": "9298",
	"./patients/fr/regis_s.png": "5994",
	"./patients/fr/snezana_d.png": "7180",
	"./patients/fr/snezana_h.png": "5a00",
	"./patients/fr/snezana_n.png": "4a37",
	"./patients/fr/snezana_s.png": "8ab8",
	"./patients/fr/vincent_d.png": "a585",
	"./patients/fr/vincent_h.png": "9add",
	"./patients/fr/vincent_n.png": "ce80",
	"./patients/fr/vincent_s.png": "4cc3",
	"./patients/lisa_d.png": "c4b8",
	"./patients/lisa_h.png": "cbc4",
	"./patients/lisa_n.png": "0c09",
	"./patients/lisa_s.png": "825a2",
	"./patients/marco_d.png": "deaf",
	"./patients/marco_h.png": "1e3e",
	"./patients/marco_n.png": "b4b9",
	"./patients/marco_s.png": "2181",
	"./patients/mark2_d.png": "2e55",
	"./patients/mark2_h.png": "47f4",
	"./patients/mark2_n.png": "e007",
	"./patients/mark2_s.png": "215a",
	"./patients/mark_d.png": "21d2",
	"./patients/mark_h.png": "8e37",
	"./patients/mark_n.png": "c1ec",
	"./patients/mark_s.png": "730d",
	"./patients/matt_d.png": "4138",
	"./patients/matt_h.png": "be8c",
	"./patients/matt_n.png": "d18f",
	"./patients/matt_s.png": "fc12",
	"./patients/paul_d.png": "4ebb",
	"./patients/paul_h.png": "afd0",
	"./patients/paul_n.png": "0339",
	"./patients/paul_s.png": "f24d",
	"./patients/peter_d.png": "b75a",
	"./patients/peter_h.png": "21e9",
	"./patients/peter_n.png": "39b7",
	"./patients/peter_s.png": "d4e3",
	"./patients/rajesh_d.png": "27ed",
	"./patients/rajesh_h.png": "40d4",
	"./patients/rajesh_n.png": "1e68",
	"./patients/rajesh_s.png": "621d",
	"./patients/ron_d.png": "9b95",
	"./patients/ron_h.png": "3f75",
	"./patients/ron_n.png": "b341",
	"./patients/ron_s.png": "091c",
	"./patients/tina_d.png": "e2c4",
	"./patients/tina_h.png": "1813",
	"./patients/tina_n.png": "3c4b",
	"./patients/tina_s.png": "2295",
	"./patients/tracee_d.png": "f94b",
	"./patients/tracee_h.png": "f163",
	"./patients/tracee_n.png": "0ee6",
	"./patients/tracee_s.png": "3205",
	"./patients/unused/10_sherry_d.png": "9a86",
	"./patients/unused/10_sherry_h.png": "6811",
	"./patients/unused/10_sherry_n.png": "d4f6",
	"./patients/unused/10_sherry_s.png": "4d8d",
	"./patients/unused/11_paul_d.png": "5528",
	"./patients/unused/11_paul_h.png": "72cf",
	"./patients/unused/11_paul_n.png": "3022",
	"./patients/unused/11_paul_s.png": "6dd4",
	"./patients/unused/12_andy_d.png": "1658",
	"./patients/unused/12_andy_h.png": "8f8c",
	"./patients/unused/12_andy_n.png": "ff9a",
	"./patients/unused/12_andy_s.png": "d706",
	"./patients/unused/13_mark_d.png": "eee2",
	"./patients/unused/13_mark_h.png": "c658",
	"./patients/unused/13_mark_n.png": "b775",
	"./patients/unused/13_mark_s.png": "dff0",
	"./patients/unused/14_julia_d.png": "2759",
	"./patients/unused/14_julia_h.png": "d350",
	"./patients/unused/14_julia_n.png": "11ac",
	"./patients/unused/14_julia_s.png": "8b51",
	"./patients/unused/15_dana_d.png": "6560",
	"./patients/unused/15_dana_h.png": "96ee",
	"./patients/unused/15_dana_n.png": "08db",
	"./patients/unused/15_dana_s.png": "b857",
	"./patients/unused/16_lisa_d.png": "f5f9",
	"./patients/unused/16_lisa_h.png": "ab6a",
	"./patients/unused/16_lisa_n.png": "5ae7",
	"./patients/unused/16_lisa_s.png": "9ec5",
	"./patients/unused/16_mark_d.png": "e7ac",
	"./patients/unused/16_mark_h.png": "f3f5",
	"./patients/unused/16_mark_n.png": "010f",
	"./patients/unused/16_mark_s.png": "622b",
	"./patients/unused/1_jeff_d.png": "1764",
	"./patients/unused/1_jeff_h.png": "495a",
	"./patients/unused/1_jeff_n.png": "0ed0",
	"./patients/unused/1_jeff_s.png": "e518",
	"./patients/unused/2_david_d.png": "c635",
	"./patients/unused/2_david_h.png": "2ecc",
	"./patients/unused/2_david_n.png": "2d7e",
	"./patients/unused/2_david_s.png": "46c6",
	"./patients/unused/3_james_d.png": "d866",
	"./patients/unused/3_james_h.png": "ee36",
	"./patients/unused/3_james_n.png": "8f1d",
	"./patients/unused/3_james_s.png": "55b8",
	"./patients/unused/4_brendan_d.png": "3246",
	"./patients/unused/4_brendan_h.png": "67ea",
	"./patients/unused/4_brendan_n.png": "756b",
	"./patients/unused/4_brendan_s.png": "dfab",
	"./patients/unused/5_irene_d.png": "a7c1",
	"./patients/unused/5_irene_h.png": "c84d",
	"./patients/unused/5_irene_n.png": "b18b",
	"./patients/unused/5_irene_s.png": "b72f",
	"./patients/unused/6_ralph_d.png": "d5d5",
	"./patients/unused/6_ralph_h.png": "7548",
	"./patients/unused/6_ralph_n.png": "03cc",
	"./patients/unused/6_ralph_s.png": "d544",
	"./patients/unused/7_george_d.png": "1902",
	"./patients/unused/7_george_h.png": "60ab",
	"./patients/unused/7_george_n.png": "3be0",
	"./patients/unused/7_george_s.png": "5932",
	"./patients/unused/8_kim_d.png": "81bb",
	"./patients/unused/8_kim_h.png": "e978",
	"./patients/unused/8_kim_n.png": "c639",
	"./patients/unused/8_kim_s.png": "8757",
	"./patients/unused/9_natalie_d.png": "c71e",
	"./patients/unused/9_natalie_h.png": "1373",
	"./patients/unused/9_natalie_n.png": "2fa7",
	"./patients/unused/9_natalie_s.png": "a710",
	"./patients/unused/lisa_d_2.png": "6208",
	"./patients/unused/lisa_d_3.png": "684d",
	"./patients/unused/lisa_h_2.png": "444a",
	"./patients/unused/lisa_h_3.png": "a4da",
	"./patients/unused/lisa_n_2.png": "19aa",
	"./patients/unused/lisa_n_3.png": "39b3",
	"./patients/unused/lisa_s_2.png": "2b62",
	"./patients/unused/lisa_s_3.png": "34f7",
	"./patients/unused/matt_d_2.png": "1583",
	"./patients/unused/matt_h_2.png": "4b2a",
	"./patients/unused/matt_n_2.png": "f305",
	"./patients/unused/matt_s_2.png": "01b2",
	"./patients/unused/paul_d_2.png": "013f",
	"./patients/unused/paul_h_2.png": "e6a4",
	"./patients/unused/paul_n_2.png": "844f",
	"./patients/unused/paul_s_2.png": "ae3d",
	"./patients/unused/ron_d_2.png": "f8b3",
	"./patients/unused/ron_d_3.png": "46be",
	"./patients/unused/ron_h_2.png": "1a1c",
	"./patients/unused/ron_h_3.png": "d464",
	"./patients/unused/ron_n_2.png": "23bc",
	"./patients/unused/ron_n_3.png": "561e",
	"./patients/unused/ron_s_2.png": "55e8",
	"./patients/unused/ron_s_3.png": "2d4f",
	"./patients/will_d.png": "d8b9",
	"./patients/will_h.png": "cdfe",
	"./patients/will_n.png": "befc",
	"./patients/will_s.png": "7353",
	"./portrait_correct.png": "683a",
	"./portrait_incorrect.png": "b921",
	"./questionmark.png": "188f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";